module.exports = __webpack_public_path__ + "static/media/menu-icon-start.6afcc161.png";